<template>
    <Scheduler></Scheduler>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const Scheduler = defineAsyncComponent(() =>
    import("../../components/Design/Scheduler.vue")
);

export default {
    name: "SchedulerPage", //The name you are in should not equal the name of the component you are importing.
    components: { Scheduler, AuthLayout },
};
</script>
